import type Login from '~/components/Login/index.vue'
import _ from 'lodash'
import dayjs from 'dayjs'
import { batchProcessRequests } from '~/utils/fetchUtils'
import {
  fetchNewsAttentionById,
  fetchNewsById,
  fetchNewsCountById,
  fetchNewsHomePageList,
  fetchNewsRelatedById,
  fetchNewsViewById
} from '~/api/newsApi'
import { fetchHRStaffServices } from '~/api/hr'
import { fetchOSSInnerChainInfo, fetchOSSNewsContent } from '~/api/ossApi'
import { ResponseCode } from '~/utils/constant'
import { handleNewDetail, handleNewsUrl } from '~/utils/common'
import { fetchExhibitionList } from '~/api/exhibition'
import { fetchSpecialTopicByResourceId } from '~/api/specialTopic'
import { fetchInnerChainPage } from '~/api/innerChain'
import autoAddLink from '~/utils/links'
import { fetchPageBanner } from '~/api/bannerApi'
import { ELocale } from '~/types/enums'
import { fixedServiceList } from '../../views/news/helper'
import { onMounted, nextTick, watch } from 'vue'

declare const BMapGL: any

export const useNewsDetails = async (_lang: ELocale) => {
  onMounted(() => {
    getService()
  })
  const { lang, $t } = useLang(_lang)
  const route = useRoute()
  const userStore = useUserStore()
  const token = useCookie('access_token', {
    domain: 'jufair.com'
  })

  const loginModal = inject<typeof Login>('loginModal')

  const { id } = route.params

  const detail = ref<Record<string, any>>({})
  const fair = ref<Record<string, any>>({})
  const news = ref<Record<string, any>[]>([])
  const newNews = ref<Record<string, any>>({})
  const tag = ref<Record<string, any>[]>([])
  const tagNews = ref<Record<string, any>[]>([])
  const banner = ref<Record<string, any>[]>([])
  const relatNew = ref<Record<string, any>[]>([])
  const sourceResult = ref<Record<string, any>>({})
  const innerChainActive = ref<number>(0)
  const innerChainAreaList = ref<Record<string, any>[]>([])
  const innerChainIndustryList = ref<Record<string, any>[]>([])
  const innerChainExhList = ref<Record<string, any>[]>([])
  const dialogShow = ref<boolean>(false)
  const dialogTitle = ref<string>('')
  const dialogImg = ref<any>('')
  const boothServiceList = ref<any[]>([])

  // filters
  const lunchTime = (data: any) => {
    const startTime = dayjs(data.startTime).format('YYYY年MM月DD日')
    const endTime = dayjs(data.endTime).format('MM月DD日')

    return `${startTime}-${endTime}`
  }

  const description = (item: Record<string, any>): any => {
    const content = item.description || item.content
    if (!_.isString(content)) return

    const reg = /<[^>]+>/gi
    let contentStr = content || ''
    const description =
      (contentStr ?? '') != ''
        ? contentStr
          ?.replace(reg, '')
          ?.replace(/&nbsp;/g, '')
          .trim()
        : ''
    return description?.slice(0, 100) + '...'
  }

  // computed
  const fairId = computed(() => {
    const { exhibitionList } = detail.value
    let id
    if (!exhibitionList) return id
    try {
      id = exhibitionList[0]?.id
    } catch (error) {
      id = null
    }
    return id
  })

  // asyncData
  const { data } = await useAsyncData('newDetailPageData', async () => {
    return await batchProcessRequests(
      [() => fetchNewsById({ id }), () => fetchOSSNewsContent({ newsId: id })],
      { parallel: true }
    )
  })
  // const { dataNewTag } = await useAsyncData('newDetailPageData5', async () => {
  //   return await batchProcessRequests(
  //     [() =>
  //           fetchNewsHomePageList({
  //             locale: detail.value.locale || 'cn',
  //             industryId: _.get(detail.value, 'industryId', null),
  //             newsType: 5,
  //             pageNum: 2,
  //             pageSize: 6
  //           }),],
  //     { parallel: true }
  //   )
  // })


  const [detailRes, bodyRes] = data.value || []

  if (typeof bodyRes !== 'string') {
    throw createError({
      statusCode: 404,
      statusMessage: '资讯不存在-oss返回错误',
      message: route.fullPath
    })
  }

  if (detailRes.code === ResponseCode.SUCCESS && detailRes.data) {
    if (!detailRes.data) {
      throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found',
        message: route.fullPath
      })
    }
    // online: 1 未上架  2已上架
    if (
      detailRes.data.online != null &&
      detailRes.data.online !== 2 &&
      !route.query.hasOwnProperty('preview')
    ) {
      throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found-已下架',
        message: route.fullPath
      })
    }

    if (typeof bodyRes == 'string') {
      detailRes.data.content = handleNewDetail(bodyRes)
    }
    detail.value = detailRes.data
    detail.value.informationSecret = detailRes.informationSecret

    // viewUrl为null 且 当前url不是information,则跳转 information
    if (!detail.value.viewUrl && !route.fullPath.includes('information')) {
      let newUrl = `/information/${detail.value.id}.html`
      navigateTo(newUrl, { external: true, redirectCode: 301 })
    }

    if (detail.value.viewUrl && !route.fullPath.includes(detail.value.viewUrl)) {
      let queryStr = '' // url ?后面的参数
      if (route.fullPath.includes('?')) queryStr = route.fullPath.split('?')[1]
      let newUrl: any = `${detail.value.viewUrl}?${queryStr}`
      navigateTo(newUrl, { external: true, redirectCode: 301 })
    }
    if (detail.value.viewUrl && !route.fullPath.includes(detail.value.viewUrl)) {
      // ctx.redirect(detail.viewUrl);
    }
  } else {
    throw createError({
      statusCode: 404,
      statusMessage: '资讯不存在!',
      message: route.fullPath
    })
  }

  if (!_.isEmpty(detail.value)) {
    const { data } = await useAsyncData('newDetailPageData2', async () => {
      return await batchProcessRequests(
        [
          () =>
            fetchExhibitionList({
              locale: detail.value.locale || 'cn',
              selectTimeType: 1,
              industryId: _.get(detail.value, 'industryId', null),
              pageNum: 1,
              pageSize: 12
            }),
          () =>
            fetchNewsHomePageList({
              locale: detail.value.locale || 'cn',
              industryId: _.get(detail.value, 'industryId', null),
              newsType: 1,
              pageNum: 1,
              pageSize: 8
            }),
          () =>
            fetchNewsHomePageList({
              locale: detail.value.locale || 'cn',
              newsType: 1,
              pageNum: 1,
              pageSize: 8
            }),
          () =>
            fetchSpecialTopicByResourceId({
              type: 1,
              resourceId: id
            }),
          () => fetchNewsViewById({ id }),
          () => fetchNewsRelatedById({ id })
        ],
        { parallel: true }
      )
    })

    const [fairRes, newsRes, newNewsRes, tagRes, viewRes, relatNewRed] = data.value || []

    if (fairRes.code === ResponseCode.SUCCESS) {
      fair.value = fairRes.data
    }

    if (newsRes.code === ResponseCode.SUCCESS && newsRes.data && newsRes.data.records) {
      for (let i = 0; i < newsRes.data.records.length; i++) {
        const item = newsRes.data.records[i]
        news.value.push({
          newsId: item.newsId,
          viewUrl: item.viewUrl,
          newsName: item.newsName,
          logo: item.logo,
          createTime: dayjs(new Date(item.publishTime)).format('YYYY-MM-DD HH:mm:ss'),
          description: i === 0 ? await fetchOSSNewsContent({ newsId: item.id }) : '',
          views: item.viewCount
        })
      }
    }

    // 最新资讯
    if (newNewsRes.code === ResponseCode.SUCCESS && newNewsRes.data && newNewsRes.data.records) {
      newNews.value = newNewsRes.data.records?.map((item: any) => ({
        newsId: item.newsId,
        viewUrl: item.viewUrl,
        newsName: item.newsName,
        logo: item.logo,
        createTime: dayjs(new Date(item.publishTime)).format('YYYY-MM-DD HH:mm:ss')
      }))
    }

    if (tagRes.code === ResponseCode.SUCCESS) {
      tag.value = tagRes.data
    }

    if (viewRes.code === ResponseCode.SUCCESS) {
      detail.value.views = viewRes.data.viewCount
    }

    //关联资讯
    if (relatNewRed.code === ResponseCode.SUCCESS) {
      relatNew.value = relatNewRed.data
    }
  }

  if (tag.value && tag.value.length > 0 || true) {
    const { data } = await useAsyncData('newDetailPageData3', async () => {
      return await batchProcessRequests(
        [
          () =>
            fetchNewsHomePageList({
              locale: detail.value.locale || 'cn',
              industryId: _.get(detail, 'industryId', null),
              newsType: 1,
              pageNum: 2,
              pageSize: 6
            })
        ],
        { parallel: true }
      )
    })

    const [newsResList] = data.value || []

    if (newsResList.code === ResponseCode.SUCCESS && newsResList.data.records) {
      for (let i = 0; i < newsResList.data.records.length; i++) {
        const item = newsResList.data.records[i]
        tagNews.value.push({
          newsId: item.newsId,
          viewUrl: item.viewUrl,
          newsName: item.newsName,
          logo: item.logo,
          createTime: dayjs(new Date(item.publishTime)).format('YYYY-MM-DD HH:mm:ss'),
          description: item.description,
          views: item.viewCount
        })
      }
    }
  }

  if (detail.value.exhibitionList && detail.value.exhibitionList.length > 0) {
    sourceResult.value = detail.value.exhibitionList[0]
  }

  // 把参考资料渲染到文章主体内容中
  let exhibitionHtmlStr = ''
  if (sourceResult.value) {
    exhibitionHtmlStr = `
            <p>参考资料：</p>
            <p style="margin:0">
                <a href="/exhibition/${sourceResult.value.id}.html" title="${sourceResult.value.exhibitionName}" style="color:#f00000;font-weight:bold;">
                    ${sourceResult.value.exhibitionName}
                </a>
            </p>`
    if (sourceResult.value.exhibitionEnglishName)
      exhibitionHtmlStr += `<p style="margin:0">${sourceResult.value.exhibitionEnglishName}</p>`
    if (sourceResult.value.area)
      exhibitionHtmlStr += `<p style="margin:0">举办地区：${sourceResult.value.area}</p>`
    if (sourceResult.value.launchTime)
      exhibitionHtmlStr += `<p style="margin:0">展会日期：${sourceResult.value.launchTime}</p>`
    if (sourceResult.value.openTime)
      exhibitionHtmlStr += `<p style="margin:0">开闭馆时间：${sourceResult.value.openTime}</p>`
    if (sourceResult.value.hostAddress)
      exhibitionHtmlStr += `<p style="margin:0">举办地址：${sourceResult.value.hostAddress}</p>`
    if (sourceResult.value.exhibitionAddress)
      exhibitionHtmlStr += `<p style="margin:0">举办展馆：${sourceResult.value.exhibitionAddress}</p>`
    if (sourceResult.value.scale)
      exhibitionHtmlStr += `<p style="margin:0">展览面积：${sourceResult.value.scale}</p>`
    if (sourceResult.value.audience)
      exhibitionHtmlStr += `<p style="margin:0">观众数量：${sourceResult.value.audience}</p>`
    if (sourceResult.value.cycle)
      exhibitionHtmlStr += `<p style="margin:0">举办周期：${sourceResult.value.cycle}</p>`
    if (sourceResult.value.industryName)
      exhibitionHtmlStr += `<p style="margin:0">所属行业：${detail.value.industryName}</p>`
    if (sourceResult.value.organizer)
      exhibitionHtmlStr += `<p style="margin:0">主办单位：${sourceResult.value.organizer}</p>`
  }

  const { data: innerChainAllRes } = await useAsyncData('newDetailPageData4', async () => {
    return await batchProcessRequests(
      [
        () =>
          fetchInnerChainPage({
            category: '热门地区',
            pageSize: 16
          }),
        () =>
          fetchInnerChainPage({
            category: '热门行业',
            industryIdList: [detail.value.industryId],
            pageSize: 16
          }),
        () =>
          fetchInnerChainPage({
            category: '热门展会',
            industryIdList: [detail.value.industryId],
            pageSize: 16
          })
      ],
      { parallel: true }
    )
  })

  const [innerChainAreaRes, innerChainIndustryRes, innerChainExhRes] = innerChainAllRes.value || []

  if (innerChainAreaRes.code === ResponseCode.SUCCESS) {
    innerChainAreaList.value = innerChainAreaRes.data.records
  }

  if (innerChainIndustryRes.code === ResponseCode.SUCCESS) {
    innerChainIndustryList.value = innerChainIndustryRes.data.records
    let len = innerChainIndustryList.value?.length
    if (len < 16) {
      const otherResult1 = await Promise.all([
        useAsyncData(() =>
          fetchInnerChainPage({
            category: '热门行业',
            pageSize: 16 - len
          }))])
      const [{ data: innerChainArea2Res }] = otherResult1
      if (_.get(innerChainArea2Res, 'value.code') === ResponseCode.SUCCESS) {
        innerChainIndustryList.value = innerChainIndustryList.value.concat(
          innerChainArea2Res?.value?.data.records
        )
      }
    }
  }

  if (innerChainExhRes.code === ResponseCode.SUCCESS) {
    innerChainExhList.value = innerChainExhRes.data.records
    let len = innerChainExhList.value.length
    if (len < 16) {
      const otherResult2 = await Promise.all([
        useAsyncData(() =>
          fetchInnerChainPage({
            category: '热门展会',
            pageSize: 16 - len
          }))])
      const [{ data: innerChainExh2Res }] = otherResult2

      if (_.get(innerChainExh2Res, 'value.code') === ResponseCode.SUCCESS) {
        innerChainExhList.value = innerChainExhList.value.concat(innerChainExh2Res?.value?.data.records)
      }
    }
  }

  // methods
  const $get = _.get
  // 初始化地图
  const initMap = () => {
    // console.log('初始化展馆地图', document.getElementById('pavilion_map'));
    let pavilion_map: any = document.getElementById('pavilion_map')
    if (!pavilion_map) {
      return false
    }
    pavilion_map.style.width = '366px'
    let pavilionNameEl: any = document.getElementById('pavilionName')
    let pavilionName: any = pavilionNameEl.innerText || ''
    let pavilionAddressEl: any = document.getElementById('pavilionAddress')
    let pavilionAddress: any = pavilionAddressEl.innerText || ''
    let latEl: any = document.getElementById('lat')
    let lngEl: any = document.getElementById('lng')
    let lat: number = latEl.innerText ? Number(latEl.innerText) : 0
    let lng: number = lngEl.innerText ? Number(lngEl.innerText) : 0

    // 120.00872654004134, 30.286195627940323
    // debugger;
    var map = new BMapGL.Map('pavilion_map') // 创建地图实例
    var point: any = new BMapGL.Point(lng, lat) // 创建点坐标
    // map.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别

    map.centerAndZoom(new BMapGL.Point(lng, lat), 15)
    map.enableScrollWheelZoom(true)

    // 标记点击事件
    // map.addEventListener('click', function (e: any) {
    //   alert('点击位置经纬度：' + e.latlng.lng + ',' + e.latlng.lat);
    // });
    var marker = new BMapGL.Marker(point) // 创建标注
    map.addOverlay(marker) // 将标注添加到地图中
    var opts = {
      width: 200, // 信息窗口宽度
      height: 30, // 信息窗口高度
      title: `${pavilionName}`, // 信息窗口标题
      message: ''
    }
    var infoWindow: any = new BMapGL.InfoWindow(`地址：${pavilionAddress}`, opts) // 创建信息窗口对象

    marker.addEventListener('click', function () {
      map.openInfoWindow(infoWindow, point) //开启信息窗口
    })
    map.openInfoWindow(infoWindow, point) //开启信息窗口
  }

  const handleHotTab = (val: number) => {
    innerChainActive.value = val
  }

  const getAndCount = () => {
    fetchNewsCountById({
      id: detail.value.id
    }).then((res: any) => {
      if (res.data?.viewCount) detail.value.views = res.data?.viewCount
    })
  }

  const fetchLinks = async () => {
    const { content, newsName } = detail.value
    const linksRes = (await fetchOSSInnerChainInfo()) as any

    const html = content //removeEmptyTags(getContent(content));

    detail.value.content = await autoAddLink(html, linksRes, newsName)
    if (detail.value.content) {
      setTimeout(() => {
        initMap()
      })
    }
    // console.log(detail.value.content,exhibitionHtmlStr,459);
  }

  const handleShowMini = async () => {
    dialogShow.value = true
    dialogTitle.value = '扫码打开小程序'
    dialogImg.value = await import('~/assets/images/juzhan-mini.jpg')
  }

  const toNewDetail = (viewUrl: string, id: number) => {
    let url = handleNewsUrl(viewUrl, id)
    window.open(url, '_blank')
  }

  const getBanner = async () => {
    const res = await fetchPageBanner({
      type: 1,
      channel: 0,
      industry2: detail.value.industryId,
      areaType: 0
    })
    if (res.code === ResponseCode.SUCCESS) {
      for (let i = 0; i < res.data.length; i++) {
        const url = res.data[i].bannerUrlList
        const link = res.data[i].bannerLinkListPc
        banner.value.push({ url, link })
      }
    }
  }

  // isLogin
  const shouldLogin = () => {
    // 获取不到token为未登录, 前往登录页
    if (!token.value) {
      loginModal?.value.open()
    }
    return !!token.value
  }

  // TODO 关注报错
  const handleAttention = async () => {
    if (shouldLogin()) {
      const res = await fetchNewsAttentionById({ id })
      if (res.code === ResponseCode.SUCCESS) {
        detail.value.focus = !detail.value.focus
        if (detail.value.focus) {
          ElMessage.success('关注成功.')
        } else {
          ElMessage.success('取消关注成功.')
        }
      }
    }
  }

  // 分享到QQ空间
  const shareToQzone = (event: any) => {
    event.preventDefault()
    const { newsName } = detail.value
    let _shareUrl = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?'
    _shareUrl += 'url=' + encodeURIComponent(document.location.href) // 参数url设置分享的内容链接|默认当前页location
    _shareUrl += '&showcount=1' // 参数showcount是否显示分享总数,显示：'1'，不显示：'0'，默认不显示
    _shareUrl +=
      '&desc=' +
      encodeURIComponent(
        detail.value.description ||
        '聚展网是国内专业国际展会一站式服务平台，帮助企业便捷参加全球展会，国际展会，企业首选的参展服务平台，公司已带领上千家企业出国参展，足迹遍布欧、美、亚、非、澳五大洲主流会展名城，为中国对外出口贸易做出重要贡献'
      ) // 参数desc设置分享的描述，可选参数
    _shareUrl +=
      '&summary=' +
      encodeURIComponent(newsName || '聚展网-展会网_国际展会_展会公司_国外展会信息服务平台') // 参数summary设置分享摘要，可选参数
    _shareUrl += '&title=' + encodeURIComponent(newsName || document.title) // 参数title设置分享标题，可选参数
    _shareUrl += '&site=' // 参数site设置分享来源，可选参数
    _shareUrl += '&pics=' + encodeURIComponent('') // 参数pics设置分享图片的路径，多张图片以＂|＂隔开，可选参数
    window.open(
      _shareUrl,
      '_blank',
      'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=800,height=600'
    )
  }

  // 分享到qq
  const shareToqq = (event: any) => {
    event.preventDefault()
    let _shareUrl = 'https://connect.qq.com/widget/shareqq/iframe_index.html?'
    _shareUrl += 'url=' + encodeURIComponent(document.location.href) // 分享的链接
    _shareUrl += '&title=' + encodeURIComponent(detail.value.newsName || document.title) // 分享的标题
    window.open(
      _shareUrl,
      '_blank',
      'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=800,height=600'
    )
  }

  const handleToPage = async (type: string) => {
    if (type === 'booth') {
      await userStore.setAction(1)
      window.open(`/exhibition/apply/${fairId.value}.html`, '_blank')
    } else if (type === 'ticket') {
      await userStore.setAction(2)
      window.open(`/ticket/${fairId.value}.html`, '_blank')
    } else if (type === 'periodical') {
      await userStore.setAction(3)
      window.open(`/periodical/${fairId.value}.html`, '_blank')
    }
  }
  // 获取客服
  const getService = async () => {
    const { industryId1, industryId2, industryId3 } = detail.value
      .exhibitionList
      ? detail.value.exhibitionList[0]
      : { industryId1: null, industryId2: null, industryId3: null };
    const newindustry = industryId1 ?? industryId2 ?? industryId3 ?? '';

    if (
      !detail.value.exhibitionList ||
      detail.value.exhibitionList.length == 0 ||
      !newindustry
    ) {
      fixedServiceList.map((item: any) => {
        item.avatar = `${item.avatar}?x-oss-process=image/auto-orient,1/interlace,1/resize,m_fill,w_70,h_70/sharpen,100`;
      });
      boothServiceList.value = fixedServiceList;
      return;
    }

    const res: any = await fetchHRStaffServices({
      exhibitionId: fairId.value,
      industry: newindustry,
      skillCodes: ['exOnlineSale', 'ticketOnlineSale'],
    });
    if (res.code === ResponseCode.SUCCESS) {
      let list = res.data;
      list.map((item: any) => {
        item.avatar = `${item.avatar}?x-oss-process=image/auto-orient,1/interlace,1/resize,m_fill,w_70,h_70/sharpen,100`;
      });
      let saleList: any = list.filter((i: any) =>
        i.skillList.some((x: any) => x.skillCode == 'exOnlineSale')
      );
      boothServiceList.value = saleList || [];
    }
  }

  // IntersectionObserver懒加载v-html图片
  function lazyLoadHtmlImages() {
    const imgs = document.querySelectorAll('.news_detail img[data-src]')
    if (!('IntersectionObserver' in window)) {
      // 兼容不支持的浏览器，直接加载
      imgs.forEach(img => {
        const dataSrc = img.getAttribute('data-src')
        if (dataSrc && !(img as HTMLImageElement).src) {
          (img as HTMLImageElement).src = dataSrc
        }
      })
      return
    }
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement
          const dataSrc = img.getAttribute('data-src')
          if (dataSrc && !img.src) {
            img.src = dataSrc
            img.removeAttribute('data-src')
          }
          observer.unobserve(img)
        }
      })
    }, { rootMargin: '100px' })
    imgs.forEach(img => {
      observer.observe(img)
    })
  }

  watch(
    [() => detail.value.content, () => exhibitionHtmlStr],
    () => {
      nextTick(() => {
        if (process.client) {
          lazyLoadHtmlImages()
        }
      })
    },
    { immediate: true }
  )


  return {
    lang_t: $t,
    $get,
    id,
    detail,
    fair,
    news,
    newNews,
    tag,
    tagNews,
    banner,
    relatNew,
    sourceResult,
    innerChainActive,
    innerChainAreaList,
    innerChainIndustryList,
    innerChainExhList,
    dialogShow,
    dialogTitle,
    dialogImg,
    lunchTime,
    description,
    fairId,
    exhibitionHtmlStr,
    initMap,
    handleHotTab,
    getAndCount,
    fetchLinks,
    handleShowMini,
    toNewDetail,
    getBanner,
    shouldLogin,
    handleAttention,
    shareToQzone,
    shareToqq,
    handleToPage,
    boothServiceList
  }
}
